import * as React from "react"
import { useState } from "react"

import { Box, Stack } from "@chakra-ui/react"

import { Paging } from "../paging/Paging"

import { usePaging } from "./usePaging"

export type OnlinePagingComponentProps = {
  selectedPage: number
  itemsPerPage: number
  totalPagingItems: number
  setSelectedPage: (page: number) => void
  setTotalPagingItems: (total: number) => void
}

export type WithOnlinePagingProps = {
  itemsPerPageCounts?: number[]
  defaultItemsPerPage?: number
}

export const withOnlinePaging = <T extends OnlinePagingComponentProps>(
  Component: React.ComponentType<T>,
): React.ComponentType<
  Omit<T, keyof OnlinePagingComponentProps> & WithOnlinePagingProps
> => {
  return ({
    itemsPerPageCounts = [5, 10, 20, 50, 100],
    defaultItemsPerPage,
    ...props
  }: WithOnlinePagingProps) => {
    const [totalPagingItems, setTotalPagingItems] = useState<number>(0)
    const {
      selectedPage,
      setSelectedPage,
      itemsPerPage,
      setItemsPerPage,
      itemsPerPageOptions,
    } = usePaging({ defaultItemsPerPage, itemsPerPageCounts })
    const newProps = {
      ...props,
      selectedPage,
      setSelectedPage,
      itemsPerPage,
      totalPagingItems,
      setTotalPagingItems,
    } as T
    return (
      <Stack alignItems="center" width={"100%"}>
        <Component {...newProps} />
        <Box
          alignSelf={{ base: "center", md: "flex-end" }}
          pt={{ base: 5, md: 10 }}
          pb={{ base: 0, md: 10 }}
        >
          {totalPagingItems > 0 && (
            <Paging
              itemsTotal={totalPagingItems}
              itemsPerPageOptions={itemsPerPageOptions}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
            />
          )}
        </Box>
      </Stack>
    )
  }
}
